import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './static-page-header.magic.css.js';
import StaticPageHeaderComponent from './static-page-header.js';

const __vue_script__ = StaticPageHeaderComponent;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "header",
      class: [
        {
          "header--one-third": _vm.oneThird,
          "header--one-fourth": _vm.oneFourth,
          "header--show-content": _vm.showContent,
          "header--top-nav": _vm.topNav
        }
      ],
      attrs: {
        "data-v-test-id": "header",
        part: _vm.$p("header", [
          {
            "header--one-third": _vm.oneThird,
            "header--one-fourth": _vm.oneFourth,
            "header--show-content": _vm.showContent,
            "header--top-nav": _vm.topNav
          }
        ])
      }
    },
    [
      _vm.page
        ? _c(
            "div",
            { staticClass: "inner", attrs: { part: "inner" } },
            [
              _vm.page.background
                ? _c("magic-ui-background", {
                    staticClass: "background",
                    attrs: {
                      part: "background",
                      path: _vm.page.background,
                      alt: _vm.page.title
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.image || _vm.page.title || _vm.page.description || _vm.content
                ? _c(
                    "div",
                    {
                      staticClass: "wrapper",
                      class: { "wrapper--top-nav": _vm.topNav },
                      attrs: {
                        part: _vm.$p("wrapper", {
                          "wrapper--top-nav": _vm.topNav
                        })
                      }
                    },
                    [
                      !_vm.hideImage && _vm.image
                        ? _c("img", {
                            staticClass: "image",
                            attrs: {
                              part: "image",
                              alt: "Image",
                              src: _vm.image
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.hideTitle && _vm.page.title
                        ? _c("magic-ui-text", {
                            staticClass: "title",
                            attrs: {
                              tag: "h3",
                              part: "title",
                              content: _vm.page.title
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.hideDescription && _vm.page.description
                        ? _c("magic-ui-text", {
                            staticClass: "text",
                            attrs: {
                              tag: "p",
                              part: "text",
                              content: _vm.page.description
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showContent && _vm.content
                        ? _c("magic-ui-text", {
                            staticClass: "content",
                            attrs: {
                              "is-markdown": "",
                              part: "content",
                              "marketing-banner-text": _vm.marketingBanner,
                              content: _vm.content
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("default")
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-108c07b4_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-108c07b4";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
